import { type ApiFetchContext, apiFetch } from "../client";
import type { BaseConfig, StorageConfig, StorageConfigRaw } from "../types/base";

export async function getBaseConfig(ctx: ApiFetchContext): Promise<BaseConfig> {
  return apiFetch<BaseConfig>(ctx, "/base/config");
}

function toNumber(value: string | null | undefined, fallback: number): number {
  if (value == null) return fallback;
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

/**
 * Pulls the warehouse storage policy off `GET /base/config` (the same endpoint
 * that carries supports/platforms — ConfigVo also inlines the storage* fields).
 * Returns a normalized {@link StorageConfig} with numeric days / CNY price.
 */
export async function getStorageConfig(ctx: ApiFetchContext): Promise<StorageConfig> {
  const raw = await apiFetch<StorageConfigRaw>(ctx, "/base/config");
  return {
    freePeriodDays: toNumber(raw.storageFreePeriod, 0),
    retentionPeriodDays: toNumber(raw.storageRetentionPeriod, 0),
    unitPriceCny: toNumber(raw.storageUnitPrice, 0),
  };
}
